import React, { forwardRef, useMemo } from 'react';
import AvailableOutletItem from './availableOutletItem';
import { useAvailableOutlet } from '../../../../peregrine/talons/ProductFullDetail/AvailableOutlet/useAvailableOutlet';
var AvailableOutlet = forwardRef(function (props, ref) {
  var outletSku = props.outletSku,
      product = props.product,
      customAttributes = props.customAttributes,
      wishlistButtonProps = props.wishlistButtonProps,
      isWishlistDialogOpen = props.isWishlistDialogOpen,
      setIsWishlistDialogOpen = props.setIsWishlistDialogOpen,
      setModalData = props.setModalData;
  var talonProps = useAvailableOutlet({
    outletSku: outletSku
  });
  var outletItems = talonProps.outletItems,
      configurableOptions = talonProps.configurableOptions;
  var availableItems = useMemo(function () {
    return outletItems === null || outletItems === void 0 ? void 0 : outletItems.map(function (item) {
      return React.createElement(AvailableOutletItem, {
        item: item,
        configurableOptions: configurableOptions,
        key: item.sku,
        product: product,
        customAttributes: customAttributes,
        wishlistButtonProps: wishlistButtonProps,
        isWishlistDialogOpen: isWishlistDialogOpen,
        setIsWishlistDialogOpen: setIsWishlistDialogOpen,
        setModalData: setModalData,
        parentImage: product === null || product === void 0 ? void 0 : product.small_image
      });
    });
  }, [outletItems, wishlistButtonProps, isWishlistDialogOpen, setModalData, setIsWishlistDialogOpen]);
  return React.createElement(React.Fragment, null, !!(outletItems !== null && outletItems !== void 0 && outletItems.length) && React.createElement("div", {
    ref: ref,
    className: "mb-20 xl_mb-32 2xl_mb-36"
  }, React.createElement("h3", {
    className: "text-center mb-12 font-bold"
  }, "AVAILABLE IN OUTLET"), availableItems));
});
export default AvailableOutlet;